module.exports = __webpack_public_path__ + "img/icon-24-ic-flash-on.a361b597.svg";